<mat-toolbar class="team-name-toolbar px-0" fxLayout="row" fxLayoutAlign="space-between center" *ngIf="teamService.team$ | async; let team">
    <app-inline-rename class="inline-rename" [value]="team.name" fxFlex="1 0 auto" (update)="renameTeam(team, $event)"></app-inline-rename>
    <div fxLayout="row" fxLayoutAlign="flex-end center">
        <div fxLayout="row">
            <div fxLayout="row" (click)="getTeamWatchers(team.id, menuTrigger); $event.preventDefault()" class="pointer">
                <app-white-button
                    [icon]="'visibility'"
                    [label]="team.watcherCount"
                    class="no-pointer-events see-more mr-8"
                    aria-label="See watchers"
                    #menuTrigger="matMenuTrigger"
                    [matMenuTriggerFor]="seeWatchers"
                >
                </app-white-button>
            </div>

            <mat-menu #seeWatchers="matMenu" class="watchers-menu" xPosition="before">
                <div fxLayout="column" *ngIf="(teamService.teamWatchers$ | async).length; else noTeamWatchers">
                    <button mat-menu-item aria-label="add" (click)="stopWatchingTeam(team)" *ngIf="team.isCurrentUserWatcher">
                        <mat-icon class="mr-8">visibility_off</mat-icon>
                        <span>{{ 'TEAMS.WATCHER.BUTTON.STOP_WATCHING' | translate }}</span>
                    </button>

                    <span class="px-16 pt-12 pb-8 font-medium">{{ 'TEAMS.WATCHER.TITLE.PLURAL' | translate }}</span>

                    <button mat-menu-item (click)="$event.stopPropagation()" *ngFor="let teamWatcher of teamService.teamWatchers$ | async">
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="w-full">
                            <div fxLayout="row" fxLayoutAlign="flex-start center">
                                <img class="avatar pointer" *ngIf="teamWatcher.avatar.src; else initials" [alt]="teamWatcher.fullName" [src]="teamWatcher.avatar.src" />
                                <ng-template #initials>
                                    <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ teamWatcher.fullName | initials }}</div>
                                </ng-template>
                                <span class="m-0">{{ teamWatcher.fullName }}</span>
                            </div>
                            <mat-icon
                                class="mr-0 remove-icon"
                                (click)="openRemoveTeamWatcherDialog(teamWatcher, team); menuTrigger.closeMenu()"
                                *ngIf="team.isCurrentUserLeader || isCurrentUserTenantAdmin"
                            >
                                close
                            </mat-icon>
                        </div>
                    </button>
                </div>

                <ng-template #noTeamWatchers>
                    <div fxLayout="column" fxLayoutAlign="center center">
                        <mat-icon class="participant-view-illustration" svgIcon="members_illustration"> </mat-icon>
                        <p class="mt-8 mb-12">
                            {{ 'TEAMS.WATCHER.LABEL.NO_WATCHERS_YET' | translate }}
                        </p>
                    </div>
                </ng-template>
                <button mat-menu-item aria-label="add" (click)="openAddWatcherDialog(team)">
                    <mat-icon class="mr-8">add</mat-icon>
                    <span>{{ 'TEAMS.WATCHER.BUTTON.ADD_WATCHER' | translate }}</span>
                </button>
            </mat-menu>
        </div>

        <button class="more-menu" mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="More" (click)="$event.stopPropagation()">
            <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
        </button>

        <mat-menu #moreMenu="matMenu" xPosition="before">
            <button mat-menu-item aria-label="move_to" (click)="openMoveToDialog(team)">
                <mat-icon class="mr-8">drive_file_move</mat-icon>
                <span>{{ 'GENERAL.BUTTON.MOVE_TO' | translate }} ...</span>
            </button>
            <button mat-menu-item aria-label="edit" (click)="openRenameTeamDialog(team)">
                <mat-icon class="mr-8">edit</mat-icon>
                <span>{{ 'GENERAL.BUTTON.RENAME' | translate }}</span>
            </button>
            <button mat-menu-item aria-label="delete" (click)="openDeleteTeamDialog(team)">
                <mat-icon class="mr-8">delete</mat-icon>
                <span>{{ 'GENERAL.BUTTON.DELETE' | translate }}</span>
            </button>
            <button mat-menu-item aria-label="add" (click)="openCreateNewTeamDialog(team)">
                <mat-icon class="mr-8">add_circle_outline</mat-icon>
                <span>{{ 'TEAMS.BUTTON.CREATE_NEW_SUBTEAM' | translate }}</span>
            </button>
        </mat-menu>
    </div>
</mat-toolbar>

<app-team [isTeamDetailsPage]="false" (teamProgressChanged)="teamProgressChanged($event)"></app-team>
